var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { createSvgIconFromGenerated } from '../utils';
var SvgCircleLogoMastercard = function SvgCircleLogoMastercard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em",
    focusable: "false",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FEF5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2 3.2h25.6v25.6H3.2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.76 9.6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.4,
    cy: 6.4,
    r: 6.4,
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.08,
    cy: 6.4,
    r: 6.4,
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M10.24 1.28a6.39 6.39 0 0 1 0 10.24 6.39 6.39 0 0 1-.04-10.2z"
  })))));
};
export default createSvgIconFromGenerated(SvgCircleLogoMastercard, "CircleLogoMastercard");